module.exports = __webpack_public_path__ + "img/Dourbie-vin-mala-coste.402610cb.png";